import { useEffect, useState } from "react";
import { getItem, setItem, LocalLanguage, USERINFO, DigitalNutritionURL, NiRestURL } from "../utils/localStorage";
import { SOUNDPILLICONSVG, DownArrowSVG } from "../assets";
import { Select } from 'antd';
import i18n from "../locales/i18n";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { ReactAppEnv } from '../types';

type selectedLangaugeType = { value: string; label: string; };
const languageOptions = [
  { value: 'ko', label: 'Korean', short: 'KOR' },
  { value: 'en', label: 'English', short: 'ENG' },
]

export default function Header() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const [language, setLanguage] = useState<selectedLangaugeType>(languageOptions[0]);
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const lang = getItem(LocalLanguage);
    // console.log(`### language: ${lang}`);
    const matchShort = matchLanguageShort(lang);
    setLanguage({ value: lang, label: matchShort });

    const auth = getItem(USERINFO);
    setUserName(auth?.nickName);
  }, []);

  const handleChangeLanguage = (selected: selectedLangaugeType) => {
    i18n.changeLanguage(selected.value);
    setItem(LocalLanguage, selected.value);

    const matchShort = matchLanguageShort(selected.value);
    setLanguage({ value: selected.value, label: matchShort });
  }

  // 사용 언어의 Short를 반환하는 메서드
  const matchLanguageShort = (value: string) => {
    const found = languageOptions.find((opt) => opt.value === value);
    return found?.short || value;
  }

  return (
    <header className="fixed top-0 left-0 w-full z-50 max-md:hidden flex px-[64px] py-[15px] justify-between items-center bg-white/75 backdrop-blur-[25px]">
      <nav 
        className="flex items-center text-[#999] text-[14px] leading-[110%] tracking-[-0.72px]" // 폰트 스타일 적용
        style={{ fontFamily: "'NanumSquare Neo', Pretendard" , fontWeight: 500 }}
      >
        <span className="flex items-center">
          <SOUNDPILLICONSVG height={26} width={32}/>
          <a
            href='/app/home'
            className="text-black text-[20px] leading-[110%] tracking-[-0.72px] pl-5"
            style={{ fontFamily: "'NanumSquare Neo', Pretendard", fontWeight: 400 }}
          >
            {t('header.soundpill')}
          </a>
        </span>
        
        <>
          {/* 현재 나이레스트 출시 전이므로 production 환경을 제외한 나머지 환경에서만 출력 */}
          <div className="flex w-[2px] h-[12px] mx-5 bg-[#E5E5E5]"></div>
          <span>
            <a href={NiRestURL} className="hover:text-[#4F68FC]">
              {t('header.goodRest')}
            </a>
          </span> 
        </> 

        <div className="flex w-[2px] h-[12px] mx-5 bg-[#E5E5E5]"></div>
        <span>
          <a href={DigitalNutritionURL} className="hover:text-[#4F68FC]">
            {t('header.digitalNutrition')}
          </a>
        </span>
      </nav>

      <div className="flex items-center space-x-10 h-[26px]">
        {/* 계정 이름 */}
        <span
          className="text-align-center text-[15px] font-weight-500 leading-[145%] cursor-pointer"
          style={{ fontFamily: 'Inter' }}
          onClick={ ()=> navigate('/app/setting/account')}
        >
          {userName}
        </span>

        <Select
          labelInValue
          value={language}
          bordered={false}
          suffixIcon={<DownArrowSVG />}
          className="bg-transparent text-black text-[15px] font-weight-500 leading-[145%]"
          style={{ width: '90px', fontFamily: 'Inter', backgroundColor: 'transparent' }}
          dropdownStyle={{
            fontFamily: 'Inter',
          }}
          onChange={handleChangeLanguage}
          options={languageOptions}
        />
      </div>
    </header>
  )
}
